import React, {Component} from 'react';
import {Provider} from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
/* router */
import {Redirect, Route, Switch} from 'react-router-dom';
import {ConnectedRouter as Router} from 'connected-react-router';
/* actions */
import {bootstrapApp} from './actions/api';
import Header from './components/Header';
import Redirector from './components/Redirector';
import ProductContainerInfinity from './components/ProductContainerInfinity';
import ProductContainerCategory from './components/ProductContainerCategory';
import ProductContainerFilter from './components/ProductContainerFilter';
import ProductContainerSearch from './components/ProductContainerSearch';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import FloatingCart from './components/FloatingCart';
import ScrollView from './components/ScrollView';
import Config from './components/Config';
import ModalRoot from './components/ModalRoot';
import PageRoot from './components/PageRoot';
import MembershipAgreementPage from './components/MembershipAgreementPage';
import OrdersPage from './components/OrdersPage';
import AddressesPage from './components/AddressesPage';
import HelpPage from './components/HelpPage';
import MyAccount from './components/MyAccount';
import NotificationsPage from './components/NotificationsPage';
import OrderHistory from './components/OrderHistory';
import UpdateDocs from './components/UpdateDocs';
import UpdateDocsPage from './components/UpdateDocsPage';
import OverlayingModal from './components/SomethingWrongModal';
import ProductDetailViewNew from './components/ProductDetailViewNew';
import ProductDetailViewNewKiosk from './components/ProductDetailViewNewKiosk';
import KioskComponentsContainer from './components/KioskComponentsContainer';
import PaymentKioskComponentsContainer from './components/PaymentKioskComponentsContainer';
import TreezLogo from './components/TreezLogo';
import * as uri from './config/uri';
import store, {history} from './store';
import injectPopStatePlugin from './helpers/injectPopStatePlugin';
import ConfigInitialized from './components/ConfigInitialized';
import {detectAndSetMode, getKioskModeUri, isKioskWithStartingUpPopUp, isPaymentKiosk} from './services/mode';
import './css/fonts/materialicons/materialicons.css';
import './css/fonts/Montserrat-Bold/montserrat-bold.css';
import './App.css';
import "./style.scss";
import './css/main.css';
import {kioskModeType} from './config/const';
import {initPaymentKioskSettings} from './services/paymentKiosk';
import GoogleMapsApi from './components/GoogleMapsApi';
import GoogleAnalyticsApi from './components/GoogleAnalyticsApi';
import {restoreAppStateBasedOnQueryParameters} from './services/uri';
import PaymentKioskAppWrapper from './components/PaymentKioskAppWrapper';
import Search from './components/Search/search_container';
import FilterBar from './components/FilterBar';
import ThemeColor from './components/ThemeColor';
import FilterModal from './components/AdvancedFilter/FilterModal';
import {hideLoader} from './helpers/loader';
import ThankYou from './components/ThankYou/ThankYou';
import Failure from './components/Failure/Failure';

const muiTheme = getMuiTheme({
  button: { textTransform: 'capitalize', fontWeight: 700 },
  datePicker: {
    selectColor: '#8bc027'
  },
  palette: {
    'primary1Color': '#8bc027',
    'pickerHeaderColor': '#8bc027'
  },
  flatButton: {
    primaryTextColor: '#8bc027'
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.isKioskMode = false;
    this.kioskMode = '';
  }

  componentWillMount() {
    hideLoader();
    const mode = detectAndSetMode(window.location.pathname);

    this.isKioskMode = mode.isKioskMode;
    this.kioskMode = mode.kioskMode;

    if (this.kioskMode === kioskModeType.PAYMENT_KIOSK) {
      initPaymentKioskSettings(window.location);
    }
    restoreAppStateBasedOnQueryParameters();
  }

  componentDidMount() {
    injectPopStatePlugin(store);
    // bootstap app, retrieve config
    store.dispatch(bootstrapApp(this.kioskMode));
  }

  renderRoutesImplementation(path, Component, isExact = false) {
    if (!Component) {
      return null;
    }

    return <Route
      path={path.replace(process.env.PUBLIC_URL, getKioskModeUri(this.kioskMode))}
      component={(props) => <Component {...props}/>}
      exact={isExact}
    />;
  }

  renderApp() {
    const appContent = (
      <div className="App">
        <Router history={history}>
          <Redirector>
            <ThemeColor />
            <GoogleMapsApi />
            <GoogleAnalyticsApi />
            <TreezLogo />
            <Header />
            <PageRoot />
            <ConfigInitialized />
            {isPaymentKiosk(this.kioskMode) && <PaymentKioskComponentsContainer />}
            {isPaymentKiosk(this.kioskMode) && <FloatingCart />}
            {this.isKioskMode && isKioskWithStartingUpPopUp(this.kioskMode) && <KioskComponentsContainer />}
            <Switch>
              {this.renderRoutesImplementation(uri.suggestionsUri, Search, true)}
              {this.renderRoutesImplementation(uri.filterUri, FilterModal, true)}
              {this.renderRoutesImplementation(uri.filterOldUri, FilterBar, true)}
              {this.renderRoutesImplementation(uri.resetPasswordUri, ProductContainerInfinity, true)}
              {this.renderRoutesImplementation(uri.ordersHistoryUri, OrderHistory, true)}
              {this.renderRoutesImplementation(uri.myaccountUri, MyAccount, true)}
              {this.renderRoutesImplementation(uri.updateDocsUri, UpdateDocs, true)}
              {this.renderRoutesImplementation(uri.updateDocsPageUri, UpdateDocsPage, true)}
              {this.renderRoutesImplementation(uri.notificationUri, NotificationsPage, true)}
              {this.renderRoutesImplementation(uri.helpUri, HelpPage, true)}
              {this.renderRoutesImplementation(uri.addressesUri, AddressesPage, true)}
              {this.renderRoutesImplementation(uri.ordersUri, OrdersPage, true)}
              {this.renderRoutesImplementation(uri.membershipUri, MembershipAgreementPage)}
              {this.renderRoutesImplementation(uri.cartUri, Cart)}
              {this.renderRoutesImplementation(uri.checkOutUri, Checkout)}
              {this.renderRoutesImplementation(`${uri.rootPageUri}category/:category/item/:product`, !isPaymentKiosk(this.kioskMode) ? ProductDetailViewNew: ProductDetailViewNewKiosk)}
              {this.renderRoutesImplementation(`${uri.rootPageUri}category/:category`, ProductContainerCategory)}
              {this.renderRoutesImplementation(uri.searchUri, ProductContainerSearch)}
              {this.renderRoutesImplementation(uri.searchReadOnlyUri, ProductContainerSearch)}
              {this.renderRoutesImplementation(uri.searchOldUri, ProductContainerFilter)}
              {this.renderRoutesImplementation(uri.thankYouUri, ThankYou)}
              {this.renderRoutesImplementation(uri.failureUri, Failure)}
              {this.renderRoutesImplementation(uri.rootPageUri, ProductContainerInfinity)}
              <Redirect to={getKioskModeUri(this.kioskMode)} push />
            </Switch>
          </Redirector>
        </Router>
      </div>
    );

    if (isPaymentKiosk(this.kioskMode)) {
      return (
        <PaymentKioskAppWrapper>
          {appContent}
        </PaymentKioskAppWrapper>
      );
    }
    else {
      return appContent;
    }
  }

  render() {
    return (
      <Provider store={store}>
        <ScrollView>
          <MuiThemeProvider muiTheme={muiTheme}>
            <Config>
              <OverlayingModal />
              <ModalRoot />
              {this.renderApp()}
            </Config>
          </MuiThemeProvider>
        </ScrollView>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx